import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["modalWrapper"];

  showModal() {
    this.modalWrapperTarget.classList.remove("hidden");
  }

  hideModal() {
    this.modalWrapperTarget.classList.add("hidden");
  }

  closeOnBackdrop(event) {
    if (event.target === this.modalWrapperTarget) {
      this.hideModal();
    }
  }
}
